let validSelected = function(){
	return (!this.selected.length>0);
};
export default validSelected;
